<template>
  <div v-if="modalStatus && modalStatus.modalName">
    <div class="ss--modal-step ss-primary-font-color u-text-bold u-mb-small u-inline-block">
      Add New Rate
    </div>

    <div class="ss-light-bg mb-2 p-2 radius-4">
      <div class="row">
        <div class="col-md-12">
          <b-alert show class="mb-2" variant="success" v-if="success.show">
            <i class="fa fa-check-circle mr-2"></i>
            <span class="sub-title mr-2" v-html="success.msg"></span>
          </b-alert>
        </div>

        <div class="col-md-3">
          <span class="c-toolbar__state-title u-text-capitalize">Display Name</span>
          <input class="form-control" type="text" v-model="form.DisplayAs" />
        </div>
        <div class="col-md-3" v-if="modalStatus.modalTitle === 'Edit Rates'">
          <span class="c-toolbar__state-title u-text-capitalize">Select Group</span>
          <v-select class="bg-white" :clearable="false" v-model="clientRate.parent" :options="listing" @input="onSelectClientRateGroup" code="id" label="displayName"></v-select>
        </div>
        <div class="col-md-1">
          <span class="c-toolbar__state-title u-text-capitalize">Qty</span>
          <input class="form-control" type="text" v-model="form.Qty" />
        </div>
        <div class="col-md-3">
          <span class="c-toolbar__state-title u-text-capitalize">Amount</span>
          <div class="input-group input-with-dollar-sign">
            <div class="input-group-prepend">
              <span class="input-group-text">$</span>
            </div>
            <input class="form-control" type="text" v-model="form.UnitPrice" />
          </div>
        </div>
        <div class="col pl-0">
          <span class="c-toolbar__state-title u-text-capitalizeh opacity-0 d-block">hidden</span>
          <button class="btn ss-warning-bg ss-white-font-color u-border-zero" :disabled="!clientRate.parent" @click="createNewItem">
            <i class="fa fa-plus u-mr-xsmall ss-white-font-color"></i>Add
          </button>
        </div>
      </div>
    </div>
    <div class="ss--modal-step ss-primary-font-color u-text-bold mt-3 u-mb-small u-inline-block">
      Edit Rates
    </div>
    <div class="row mb-3">
      <div class="col-md-6">
        <span class="c-toolbar__state-title u-text-capitalize">Select Group</span>
        <v-select class="bg-white" :clearable="false" v-model="clientRate.parent" :options="listing" @input="onSelectClientRateGroup" code="id" label="displayName"></v-select>
      </div>
    </div>
    <table class="table" id="datatable-modal-specific-listing">
      <thead class="c-table__head c-table__head--slim">
        <tr class="c-table__row">
          <th class="c-table__cell c-table__cell--head no-sort w-50px"></th>
          <th class="c-table__cell c-table__cell--head no-sort w-200px">Display Name</th>
          <th class="c-table__cell c-table__cell--head no-sort w-100px">Quantity</th>
          <th class="c-table__cell c-table__cell--head no-sort">Unit Price</th>
          <th class="c-table__cell c-table__cell--head no-sort">Account</th>
          <th class="c-table__cell c-table__cell--head no-sort text-center w-150px">System</th>
          <th class="c-table__cell c-table__cell--head no-sort w-150px text-right"></th>
        </tr>
      </thead>
      <tbody>
        <tr class="c-table__row" v-for="(item, idx) in list" :key="item.id">
          <td>
            <div v-if="!showSaveButton(idx) && !item.isSystem">
              <a class="edit-link" href="#" @click="editItem(item)">Edit</a>
            </div>
            <span v-else-if="showSaveButton(idx)">
              <a class="edit-link" href="#" @click="saveItem(idx, item)">Save</a>
            </span>
            <span v-else>&nbsp;</span>
          </td>
          <td>
            <span v-if="!showSaveButton(idx)" :class="[{'strike-through': item.isDisabled}]">{{ item.displayName }}</span>
            <span v-else><input type="text" class="form-control" v-model="item.displayName"/></span>
          </td>
          <td>
            <span v-if="!showSaveButton(idx)" :class="[{'strike-through': item.isDisabled}]">
              {{ item.qty }}
            </span>
            <span v-else><input type="text" class="form-control" v-model="item.qty"/></span>
          </td>
          <td>
            <span v-if="!showSaveButton(idx)" :class="[{'strike-through': item.isDisabled}]">
              ${{ item.unitPrice }}
            </span>
            <span v-else>
              <div class="input-group input-with-dollar-sign">
                <div class="input-group-prepend">
                  <span class="input-group-text">$</span>
                </div>
                <input type="text" class="form-control" v-model="item.unitPrice" />
              </div>
            </span>
          </td>
          <td>
            <span v-if="!showSaveButton(idx)" :class="[{'strike-through': item.isDisabled}]">
              {{ item.accountId }}
            </span>
            <span v-else><input type="text" class="form-control" v-model="item.accountId"/></span>
          </td>
          <td class="align-middle">
            <div class=" c-choice c-choice--checkbox mb-0 text-center disabled">
              <input class="c-choice__input" :id="`is-system-${item.id}`" name="checkboxes" type="checkbox" :checked="item.isSystem" disabled />
              <label class="c-choice__label" :for="`is-system-${item.id}`"></label>
            </div>
          </td>
          <td class="text-right d-flex align-items-center justify-content-end">
            <button :class="['btn mr-2 px-2', {'c-btn-outlined-gray': !item.isDisabled, 'c-btn-outlined-success': item.isDisabled}]" @click="disableItem(idx, item)">
              <i :class="['fa u-text-large', {'fa-ban': !item.isDisabled, 'fa-check': item.isDisabled}]"></i>
              {{ item.isDisabled ? "Enable" : "Disable" }}
            </button>

            <span v-if="!item.isSystem" class="clickable" @click="deleteItem(idx, item)"><i class="fa fa-trash u-text-danger u-text-larger vertical-middle"></i></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import GlobalServices from "@/services/global";
  // https://www.npmjs.com/package/vue-swatches
  import MODULE from "@/constants/modules";
  import "vue-swatches/dist/vue-swatches.css";
  const global = new GlobalServices();
  export default {
    name: "SpecificListing",
    data() {
      return {
        form: {
          DisplayAs: null,
          UnitPrice: null,
          Qty: 1,
          HTMLColour: "#6e0677",
          Status: null,
          moduleId: undefined,
        },
        success: {
          show: false,
          msg: "",
        },
        modalStatus: {},
        listing: [],
        metadata: null,
        error: null,
        selected: null,
        timer: null,
        clientRate: {
          show: false,
          parentActionId: MODULE.CLIENTS.UX.ClientRateGroup,
          actionId: MODULE.CLIENTS.UX.ClientRates,
          parent: null,
          listing: [],
          metadata: null,
        },
      };
    },
    components: {},
    computed: {
      list() {
        return this.clientRate.listing;
      },
      isLabelModule() {
        return this.modalStatus.data && this.modalStatus.data.actionId === MODULE.INVOICE.UX.InvoiceLabels;
      },
    },
    methods: {
      async onSelectClientRateGroup() {
        const results = await global.getSimpleUXDropDown(this.clientRate.actionId, this.clientRate.parentActionId, this.clientRate.parent.id);
        this.clientRate.listing = results;
        this.clientRate.metadata = await global.getUXDropDownMetadata(this.clientRate.actionId);
      },
      async createNewItem() {
        try {
          if (this.modalStatus.data.moduleId) {
            this.form.moduleId = this.modalStatus.data.moduleId;
          }

          if (this.form.UnitPrice === null) {
            delete this.form.UnitPrice;
          }

          if (this.form.DisplayAs) {
            this.form.Status = this.form.DisplayAs;
            this.form.Name = this.form.DisplayAs;
          }

          let actionId = this.modalStatus.data.actionId;
          if (this.clientRate.parent) {
            actionId = this.clientRate.actionId;
            this.form.IntClientRateGroupID = this.clientRate.parent.id;
          }

          let result = await global.createNewActivity(actionId, this.form);

          if (result.success) {
            this.success = {
              show: true,
              msg: `Successfully added new item: <strong>${this.form.DisplayAs}</strong>`,
            };

            this.form.DisplayAs = null;
            this.form.Status = null;
            this.form.HTMLColour = null;
            this.form.moduleId = undefined;
            this.form.UnitPrice = null;
            const item = result.resources;

            // insert to the list our newly added item
            this.clientRate.listing = [
              {
                displayName: item.DisplayAs,
                htmlColour: item.HTMLColour,
                unitPrice: item.UnitPrice,
                qty: item.Qty,
                sortOrder: 0,
                icon: "",
                isDefault: false,
              },
            ].concat(this.clientRate.listing);

            setTimeout(() => {
              this.success.show = false;
              this.initializeData();
            }, 3000);
          }
        } catch (err) {
          this.error = err.response;
        }
      },
      showSaveButton(idx) {
        return this.selected === this.list[idx];
      },
      async initializeData() {
        this.modalStatus = this.$store.getters.getModalStatus;
        this.listing = await global.getUXDropDown(this.modalStatus.data.actionId, this.modalStatus.data.moduleId, null, null, null, null, {
          deleted: true,
          disabled: true,
        });
        this.metadata = await global.getUXDropDownMetadata(MODULE.CLIENTS.UX.ClientRates);
      },
      editItem(item) {
        this.selected = item;
      },
      async saveItem(index, item) {
        await this.updateField(this.metadata.displayAsColumnName ? this.metadata.displayAsColumnName.trim() : "Name", item.displayName, "Display Name", item.id, true);
        await this.updateField("HTMLColour", item.htmlColour, "Colour", item.id, true);
        await this.updateField("Icon", item.icon, "Icon", item.id, true);
        await this.updateField(this.metadata.sortColumnName ? this.metadata.sortColumnName.trim() : "SortOrder", item.sortOrder ? item.sortOrder : 0, "Sort Order", item.id, true);
        await this.updateField("Amount", item.unitPrice, "Amount", item.id, true);
        await this.updateField("Quantity", item.qty, "Quantity", item.id, true);
        this.success = {
          show: true,
          msg: `Successfully updated item: <strong>${item.displayName}</strong>`,
        };

        this.list[index] = item;
        this.selected = null;

        setTimeout(() => {
          this.success.show = false;
        }, 3000);
      },
      async disableItem(index, item) {
        const isDisabled = item.isDisabled !== null ? !item.isDisabled : true;
        this.list[index].isDisabled = isDisabled;
        await this.updateField("isDisabled", isDisabled, "is Disable", item.id);
        // setTimeout(() => {
        //   this.initializeData();
        // }, 1000);
      },
      async deleteItem(index, item) {
        const isDeleted = item.isDeleted !== null ? !item.isDeleted : true;
        this.list.splice(index, 1);
        await this.updateField("isDeleted", isDeleted, "is Deleted", item.id);
        setTimeout(() => {
          this.initializeData();
        }, 1000);
      },
      async updateDefault(item) {
        // this.selected = item;
        for (const i of this.list) {
          if (parseInt(i.id) !== parseInt(item.id) && i.isDefault) {
            await this.updateField("isDefault", false, "Is Default", i.id, true);
          }
        }
        await this.updateField("isDefault", item.isDefault, "Is Default", item.id, true);

        setTimeout(() => {
          this.initializeData();
          // this.selected = null;
        }, 1000);
      },
      async updateField(propertyName, propertyValue, displayName, itemId = null, immediate = false) {
        let editObj = {};
        editObj.propertyName = propertyName;
        editObj.propertyValue = propertyValue;
        editObj.displayName = displayName;
        editObj.id = itemId;
        editObj.actionId = this.clientRate.actionId;
        if (this.modalStatus.data.moduleId) {
          editObj.moduleId = this.modalStatus.data.moduleId;
        }
        editObj.isUXProperty = true;
        let isValid = await this.isValidated(propertyName, propertyValue);

        if (isValid) {
          this.postAPIData(editObj, immediate);
        }
      },
      async isValidated(propertyName, propertyValue) {
        //Prevent empty value from being sent
        if (propertyValue == null || propertyValue.length == 0) return false;

        return true;
      },
      async postAPIData(dataObj, immediate = false) {
        if (immediate) {
          await global.postData(dataObj);
        } else {
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
          this.timer = setTimeout(() => {
            global.postData(dataObj);
          }, 500);
        }
      },
    },
    created() {
      this.MODULE = MODULE;
    },
    mounted() {
      this.initializeData();
    },
  };
</script>

<style lang="scss">
  .strike-through {
    text-decoration: line-through;
  }

  .c-choice.c-choice--checkbox.disabled .c-choice__input+.c-choice__label::before{
    background: #e5e5e5;
    border-color: #b0b0b0;
    color: #b0b0b0;
  }
</style>
